import { useState, useEffect } from 'react'
import VerificationFlow from './components/VerificationFlow'
import EmbedWrapper from './components/EmbedWrapper'
import { resolveToken } from './utils/verificationApi'
import './styles/design-system.css'
import './styles/App.css'

function App() {
  console.log('[APP] Rendering App component')

  const [initialUserData, setInitialUserData] = useState(null)
  const [tokenError, setTokenError] = useState(null)
  const [loading, setLoading] = useState(false)

  // Check if we're in embed mode
  const isEmbedMode = window.location.pathname === '/embed' ||
                      window.location.pathname === '/embed/'

  useEffect(() => {
    if (isEmbedMode) return

    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')

    if (token) {
      // Resolve encrypted token from backend
      setLoading(true)
      resolveToken(token)
        .then(data => {
          setInitialUserData({
            nome: data.nome || '',
            cpf: (data.cpf || '').replace(/\D/g, ''),
            id_cliente: data.id_cliente || null,
            id_billing: data.id_billing || null,
            locked: true
          })
        })
        .catch(() => {
          setTokenError('Link de verificação inválido ou expirado. Solicite um novo link.')
        })
        .finally(() => setLoading(false))
    } else {
      // Read plain params (fallback without encryption)
      setInitialUserData({
        nome: params.get('nome') || '',
        cpf: (params.get('cpf') || '').replace(/\D/g, ''),
        id_cliente: null
      })
    }
  }, [])

  if (isEmbedMode) {
    return <EmbedWrapper />
  }

  if (loading) {
    return (
      <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Carregando verificação...</p>
      </div>
    )
  }

  if (tokenError) {
    return (
      <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: '1rem' }}>
        <p style={{ color: '#e53e3e', textAlign: 'center', padding: '1rem' }}>{tokenError}</p>
      </div>
    )
  }

  return (
    <div className="app">
      <VerificationFlow initialUserData={initialUserData} />
    </div>
  )
}

export default App
